import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./MainPage.module.css";
import { Header, Sidebar } from "components/layout";
import { MenuItem } from "react-pro-sidebar";
import { Logout, AdminPanelSettings, TextSnippetOutlined, AccountCircleOutlined,
    TabletAndroidOutlined, AppsOutlined, MenuOutlined,
    NumbersOutlined, Lock, ShoppingBagOutlined,
    SettingsOutlined} from "@mui/icons-material";
import { Routes, Route, NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { useGetAppsQuery } from "services/data/DataService";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/auth/authSlice";
import { FullScreenLoader } from "components/loaders";
import DevicePage from "../DevicePage";
import ProfilePage from "../ProfilePage";
import RangePage from "../RangePage";
import { FullScreenError } from "components/errors";
import { IconButton } from "components/buttons";
import { useNavigate } from 'react-router-dom';
import AppPage from "../AppPage";
import LicencePage from "../LicencePage";
import SettingPage from "../SettingPage";
import ReportPage from "../ReportPage";
import { SearchBar } from "components/forms";
import ToolbarManager from "../ToolbarManager";
import * as licence from "../LicencePage/SearchBar";
import * as device from "../DevicePage/SearchBar";
import * as profile from "../ProfilePage/SearchBar";
import * as app from "../AppPage/SearchBar";

const TOOLBARS = {
    licence,
    device,
    profile,
    app
};

const MainPage = () => {

    const [collapsedBar, setCollapsedBar] = useState(false);
    const [activeToolbar, setActiveToolbar] = useState(null);
    const [extra, setExtra] = useState(null);

    const {userInfo, accessToken, rememberUser, error} = useSelector(state => state.auth);
    const { selectedDevice, activeDetails } = useSelector(state => state.device);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => { 
        if(error || (!accessToken && !rememberUser)) {
            dispatch(logout());
        }
    }, [accessToken]);

    /*useEffect(() => {

    }, []);*/

    const getDeviceUrl = () => {
        if(selectedDevice && activeDetails) return `/devices/${selectedDevice.id}/${activeDetails.value}`;
        return '/devices';
    };

    const onLogout = () => {
        dispatch(logout());
    };

    
    /*if(error) {
        return <FullScreenError />;
    }*/

    if (!accessToken) {
        return <FullScreenLoader />;
    }
    
    const headerItems =
        <>
            {/*userInfo.roles.includes('admin') ?
                <IconButton
                    text="Перейти в Админку"
                    iconCmp={<AdminPanelSettings />}
                    handler={onAdmin}
                /> : null*/} 
            <IconButton
                text="Выйти из кабинета"
                iconCmp={<Logout />}
                handler={onLogout}
            />
        </>;

    return (
        <div className={styles.wrapper}>
            <div className={styles.menuWrapper}>
                <Sidebar
                    collapsed={collapsedBar}
                    className={styles.menu}    
                >
                    <MenuItem
                        icon={<MenuOutlined />}
                        onClick={ () => setCollapsedBar(!collapsedBar) }
                    >
                        <h1>Кабинет</h1> 
                    </MenuItem>
                    <MenuItem 
                        icon={< TabletAndroidOutlined />}
                        component={<NavLink to={getDeviceUrl()} className="link" />}
                    >
                        Кассы
                    </MenuItem>
                    <MenuItem
                        icon={< AppsOutlined />}
                        component={<NavLink to="/apps" className="link" />}
                    >
                        Приложения
                    </MenuItem>
                    <MenuItem 
                        icon={< ShoppingBagOutlined/>}
                        component={<NavLink to="/profiles" className="link" />}
                    > 
                        Профили 
                    </MenuItem>
                    <MenuItem 
                        icon={< NumbersOutlined/>}
                        component={<NavLink to="/ranges" className="link" />}
                    > 
                        Заводские номера 
                    </MenuItem>
                    <MenuItem
                        icon={< Lock />}
                        component={<NavLink to="/licences" className="link" />}
                    >
                        Лицензии
                    </MenuItem>
                    <MenuItem
                        icon={< TextSnippetOutlined />}
                        component={<NavLink to="/reports" className="link" />}
                    >
                        Отчёты
                    </MenuItem>
                    <MenuItem
                        icon={< SettingsOutlined />}
                        component={<NavLink to="/settings" className="link" />}
                    >
                        Настройки
                    </MenuItem>
                </Sidebar>
            </div>  
            <div className={styles.contentWrapper}>
                <Header
                    search={<ToolbarManager type={activeToolbar} data={TOOLBARS[activeToolbar]}/>}
                    user={userInfo?.userName}
                    items={headerItems}
                    extra={extra}
                />
                <section className={styles.content}>
                    <Routes>
                        
                        <Route path="/" element={<Navigate to="/devices" replace />} />
                        <Route path='*' element={<h2>Страница не найдена!</h2>} />   

                        <Route path="devices/*" element={<DevicePage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS}/>} />
                        <Route path="profiles" element={<ProfilePage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS}/>} />
                        <Route path="apps" element={<AppPage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS}/>} />
                        <Route path="ranges" element={<RangePage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS}/>} />
                        <Route path="licences" element={<LicencePage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS} setExtra={setExtra}/>} />
                        <Route path="reports" element={<ReportPage setActiveToolbar={setActiveToolbar} defaultSearch={TOOLBARS}/>} />
                        <Route path="settings" element={<SettingPage setActiveToolbar={setActiveToolbar} />} />
                    </Routes>
                </section>
            </div>
        </div>
        
    );
};

export default MainPage;